export default {
  "fr": {
    "dashboard": {
      "greetings": "Bonjour {first_name}",
      "titles": {
        "activityFeed": "Activités",
        "assignedTasks": "Mes Tâches pour",
        "newsFeed": "Fil d'Actualité",
        "ongoingTickets": "En Cours",
        "openTickets": "Ouvert",
        "tickets": "Conversations",
        "totalTickets": "Toutes",
        "unreadTickets": "Non Lu",
        "yourAssignedTickets": "Vos conversations assignées"
      }
    }
  }
}